import axios  from 'axios';
import EventBus from './EventBus'; 
import store from '../store/index';
import router from '../router';

class Api {


    constructor() {
        this.api = axios.create({
            baseURL: '/api/v1'
        });
    }

    request(type, url, data, requestName="ApiService", customToken){
        const token   = (customToken) ? customToken : store.getters['user/token'];
        const headers = (token) ? {'Authorization':'JWT ' + token} : {};

        EventBus.$emit('loading', requestName);

        const promise = this.api({
            method: type,
            url,
            data: (data) ? data : null,
            headers
        });

        promise.then((res)=>{
            EventBus.$emit('loaded', requestName);
        });
        promise.catch((err)=>{
            EventBus.$emit('loaded', requestName);
            if(err.response && err.response.data && err.response.data.message) EventBus.$emit('error', err.response.data.message);
            if(err.response.status == 401){
                EventBus.$emit('error', "Sorry, you're not autorized for that...");
                store.commit('user/unsetToken');
                router.push('/login');
            }
        });
        return promise;
    }

    // User
    login(username, password){
        return this.request('post', '/users/login', {
            name: username,
            password
        }, 'user.login');
    }

    deleteUserAccount(userId, password){
      return this.request('delete', '/users', {
        id: userId,
        password
      }, 'user.delete');
    }

    mailExists(mail){
        return this.request('get', '/users/mailexists/'+mail);
    }

    userExists(username){
        return this.request('get', '/users/usernameexists/'+username);
    }

    register(email, username, password){
        return this.request('post', '/users', {
            name: username,
            password,
            email
        }, 'user.register');
    }

    forgotPw(email){
        return this.request('post', '/users/lostpassword', {email}, 'user.forgotpw');
    }

    retrievePw(pwKey){
        return this.request('post', '/users/resetpassword', {pwKey}, 'user.retrievepw');
    }

    getUserInfo(token){
        return this.request('get', '/users/info', null, 'user.info', token);
    }

    changeUserEmail(email){
        return this.request('put', '/users/email', {email}, 'user.changemail');
    }

    changeUserPassowrd(password){
        return this.request('put', '/users/password', {password}, 'user.changepassword');
    }

    changeUserContentTypes(contentTypes){
        return this.request('put', '/users/contentTypes', {contentTypes}, 'user.changecontentTypes');
    }

    getUserFollowdBlogs(){
        return this.request('get', '/users/follows', null, 'user.follows');
    }

    sendFeedback(formData){
        return this.request('post', '/users/feedback', formData, 'user.sendFeedback');
    }

    reblog(blogUrl, postId){
        return this.request('post', '/blogs/'+blogUrl+'/reblog/'+postId, null, 'post.reblog');
    }

    toggleFollowBlog(blogUrl){
        return this.request('post', '/users/follow/'+blogUrl, null, 'blog.follow');
    }

    // Likes
    likePost(post){
        return this.request('post', '/users/like/' + post._id, null, 'post.like');
    }

    unLikePost(post){
        return this.request('post', '/users/unlike/' + post._id, null, 'post.unlike');
    }

    getLikedPosts(lastPost){
        let q = lastPost ? '?last='+lastPost : '';
        return this.request('get','/posts/liked'+q, {}, 'likedposts.get');
    }

    // Comments
    postComment(post, text){
        return this.request('post', '/posts/' + post._id + '/comment', {text:text}, 'post.addComment');
    }

    deleteComment(post, comment){
        return this.request('delete', '/posts/' + post.post._id + '/comment/' + comment._id, null, 'post.deleteComment');
    }

    getExtendedPostInfo(post){
        return this.request('get', '/posts/' + post._id + '/extended', null, 'post.extendedInfo')
    }


    // Public Blogs
    getBlogs(offset){
        let q = offset ? '?offset='+offset : '';
        return this.request('get', '/blogs'+q, null, 'blogs')
    }

    getBlogListByType(type, offset){
        let t = type ? type : 'best';
        let q = offset ? '?offset='+offset : '';
        return this.request('get', '/blogs/list/'+t+q, null, 'blogs')
    }

    getBlogTop20(){
        return this.request('get', '/blogs/top20', null, 'blog.top20');
    }

    searchBlogs(query, offset){
        let q = offset ? '?offset='+offset : '';
        return this.request('get', '/blogs/search/'+encodeURIComponent(query)+q, null, 'blogs')
    }

    getBlog(blogUrl){
        return this.request('get', '/blogs/'+blogUrl, null, 'blog.get');
    }

    getBlogPosts(blogUrl, lastPost){
        let q = lastPost ? '?last='+lastPost : '';
        return this.request('get', '/blogs/'+blogUrl+"/posts"+q, null, 'blog.getPosts');
    }

    searchSuggest(query){
        return this.request('get', '/blogs/tags/'+query, null, 'search.suggest');
    }


    // User Blogs

    getUserBlogs(){
        return this.request('get', '/users/blogs', null, 'user.getBlogs');
    }

    getUserBlogFollower(blogObj, page){
        return this.request('get', '/users/blog/'+blogObj.url+'/follower/'+page, null, 'user.getBlogFollower');
    }

    createBlog(blogObj){
        return this.request('post', '/blogs', blogObj, 'blog.create');
    }

    updateBlog(blogObj){
        return this.request('put', '/blogs/'+blogObj._id, blogObj, 'blog.update');
    }

    deleteBlog(blogObj){
        return this.request('delete', '/blogs/'+blogObj._id, null, 'blog.delete');
    }




    // Tumblr Auth
    tumblrGetAuth(){
        return this.request('get', '/users/synctumblr/getauth', null, 'user.tumblr.getAuth');
    }

    tumblrVerifyAuth(token, secret, verifier){
        return this.request('post', '/users/synctumblr/verify', {
            token,
            secret,
            verifier
        }, 'user.tumblr.verifyAuth');
    }

    tumblrUserInfo(token, secret){
        return this.request('post', '/users/synctumblr/userinfo',{
            token, secret
        }, 'user.tumblr.getUserInfo');
    }

    tumblrSyncBlog(token, secret, blogName){
        return this.request('post', '/users/synctumblr/sync/'+blogName, {
            token, secret
        }, 'user.tumblr.import')
    }






    // Video Info
    getVideoInfo(videoUrl){
        return this.request('get','/posts/videoinfo?url='+encodeURI(videoUrl), null, 'post.getVideoInfo');
    }



    // Posts
    getPosts(lastPost){
        let q = lastPost ? '?last='+lastPost : '';
        return this.request('get','/posts'+q, {}, 'posts.get');
    }

    getPost(postId){
        return this.request('get', '/posts/post/'+postId, 'post.get');
    }

    getVideoUrl(postId){
        return this.request('get','/posts/videourl/'+postId, null, 'posts.getVideoUrl');
    }

    addPost(blogUrl, postUrl){
        return this.request('post', '/posts/', {blogUrl: blogUrl, url: postUrl}, 'post.add');
    }

    deletePost(postId){
        return this.request('delete', '/posts/'+postId, {}, 'post.delete');
    }

    updatePostDuration(postId, duration){
        return this.request('put', '/posts/' + postId + '/updateDuration', {duration}, 'post.updateDuration')
    }


    getConversations(){
        return this.request('get', '/messenger', {}, 'messenger.getConversations');
    }

    getUnreadMessages(){
        return this.request('get', '/messenger/unreadMessages');
    }

    getConversationByBlogUrl(blogUrl){
        return this.request('get', '/messenger/blog/'+blogUrl);
    }

    getConversationByUserIdAndBlogUrl(userId, blogUrl){
      return this.request('get', '/messenger/blog/'+blogUrl+'/user/'+userId);
    }

    getConversationById(conversationId){
        return this.request('get', '/messenger/conversation/' + conversationId);
    }


}

export default new Api();



// WEBPACK FOOTER //
// ./src/services/ApiService.js